/**
 * Collect PDP properties for line_item
 *
 * @param {}
 * @return {void}
 */

export const addProperties = () => {
  const radioSlatClass = '.js-radio-slat-size';
  const selectOptionClass = '.js-select-option';
  const radioOptionClass = '.js-radio-option';
  const radioControlClass = '.js-radio-control';
  const fieldsClass = '.js-field-measurement';
  const $slatProps = $('#slat-props');
  const $sizesProps = $('#sizes-props');
  const $controlProps = $('#control-props');
  const $optionsProps = $('#options-props');

  let selectedSlatValues = '';
  let selectedSizesValues = '';
  let selectedControlValues = '';
  let selectedOptionsValues = '';

  $(`${radioSlatClass}:checked`).each(function(i) {
    const text = $(this).data('slatsize');
    const value = $(this).val();

    selectedSlatValues += `${text} Slat `;
  });

  $(fieldsClass).each(function(i) {
    let value = $(this).val();
    const label = $(this).data('props-label');
    const measurement = $(this).parent().find('.js-measurement-label').text();

    if (value.length !== 0) {
      if (label == 'drop') {
        value = `x ${value}`;
      }
      selectedSizesValues += `${value}${measurement} ${label} | `;
    }
  });

  $(`${selectOptionClass} option:selected`).not(`${selectOptionClass} option:disabled`).each(function(i) {
    const text = $(this).text();

    if ($(this).parent().attr('name').indexOf('fitting') > -1) {
      selectedSizesValues += `(${text}) | `;
    } else {
      selectedOptionsValues += `${text} | `;
    }
  });

  $(`${radioOptionClass}:checked`).each(function(i) {
    const label = $(this).data('props-label');

    if ($(this).attr('name').indexOf('fitting') > -1) {
      selectedSizesValues += `(${label}) | `;
    } else {
      selectedOptionsValues += `${label} | `;
    }
  });

  $(`${radioControlClass}:checked`).each(function(i) {
    const label = $(this).data('props-label');

    selectedControlValues += `${label} | `;
  });

  $slatProps.val(selectedSlatValues);
  $sizesProps.val(selectedSizesValues);
  $controlProps.val(selectedControlValues);
  $optionsProps.val(selectedOptionsValues);
}

$('.js-radio-option').on('change', function() {
  addProperties();
});

$('.js-radio-control').on('change', function() {
  addProperties();
});

$('.js-radio-measurement').on('change', function() {
  addProperties();
});

$('.js-select-option').on('change', function() {
  addProperties();
});

$('.js-field-measurement').on('blur', function() {
  addProperties();
});

